import api from "./httpClient";

/**
 * GET /api/Branch/All
 * Response example:
 * {
 *   "data": ["BB BB", "BB KD", ...]
 * }
 */
export const getAllBranches = async (signal) => {
	const res = await api.get("/Branch/All", { signal });
	const payload = res?.data;
	const list = payload?.data ?? payload;
	return Array.isArray(list) ? list : [];
};

export default {
	getAllBranches,
};
